import React from 'react'
import styles from '../search.module.css'
import Navbar  from '../Components/Navbar'
export default function GeneralLayout({children}) {
  return (
    <div className={styles.container}>
      <Navbar />
      {children}
    </div>  
  )
}
